import React, {Component} from 'react'
import {connect} from 'react-redux'
import {buildUrlFromParams} from '../../common/functions/url'
import WithAjax from '../../common/helpers/WithAjax'
import {setJumbotronTitle} from '../../../actions/common'
import ProductionSearch from './ProductionSearch'
import ProductionList from '../ProductionList'

class ProductionSearchAndList extends Component {
  constructor() {
    super()
    this.onSearch = this.onSearch.bind(this)

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    this.props.setJumbotronTitle('Past productions');
  }

  onSearch() {
    var searchTextField = this.props.productionSearchFields.find((el) => {
      return el.name === 'SearchText';
    });

    let url = buildUrlFromParams(
      'productions/finished', 
      {
        searchText: searchTextField.value
      });

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].Id;
      });
      this.setState({
        items: data
      })
    })
  }

  render() {
    return (
      <div>
        <ProductionSearch onSearch={this.onSearch} />
        <ProductionList items={this.state.items} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.common.isLoading,
  productionSearchFields: state.productionSearch.fields
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(ProductionSearchAndList))